import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles, Copy, CheckCircle } from 'lucide-react';
import { HeadlineCard } from './HeadlineCard';
import { Button } from '../../../shared/components/ui/button';
import { toast } from 'sonner';

export const ResultsSection = ({ results }) => {
  if (!results) return null;

  const { headlines } = results;

  const copyAllHeadlines = async () => {
    const allText = headlines.map((h, i) => `${i + 1}. ${h}`).join('\n\n');
    try {
      await navigator.clipboard.writeText(allText);
      toast.success('All headlines copied to clipboard!');
    } catch (err) {
      toast.error('Failed to copy headlines');
    }
  };

  return (
    <section className="py-12 md:py-16 bg-muted/30">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
        >
          {/* Section Header */}
          <div className="text-center mb-10">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-success/10 text-success mb-4">
              <CheckCircle className="w-4 h-4" />
              <span className="text-sm font-medium">Headlines Generated Successfully</span>
            </div>
            <h2 className="font-display text-3xl md:text-4xl font-bold text-foreground mb-3">
              Your Optimized Headlines
            </h2>
            <p className="text-muted-foreground text-lg max-w-2xl mx-auto">
              Here are 3 personalized, value-driven LinkedIn headlines crafted just for you
            </p>
          </div>

          {/* Headlines List */}
          <div>
            <div className="flex items-center justify-between mb-6">
              <h3 className="font-display text-xl font-semibold text-foreground flex items-center gap-2">
                <Sparkles className="w-5 h-5 text-primary" />
                Your Top 3 Headlines
              </h3>
              <Button variant="outline" size="sm" onClick={copyAllHeadlines} className="gap-2">
                <Copy className="w-4 h-4" />
                Copy All
              </Button>
            </div>
            <div className="space-y-4">
              {headlines.map((headline, index) => (
                <HeadlineCard
                  key={index}
                  headline={headline}
                  index={index}
                />
              ))}
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
